export const server = "https://prdserver.appdeploy.in/api";

export const defaultUserImage = "";
